import { Theme } from '@mui/material/styles'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const PageStyles: moduleStyleType = {
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
    },
}

export const MenuStyles: moduleStyleType = {
    container: (theme: Theme) => ({
        '& .MuiMenu-paper': {
            boxShadow: theme.shadows[1],
            borderRadius: '6px',
        },
    }),
}

export const policyTypeIconStyles: moduleStyleType = {
    iconRevoke: {
        fill: 'error.main',
    },
    iconRequest: {
        fill: 'success.main',
    },
    alignCenter: {
        verticalAlign: 'middle',
        display: 'inline-block',
    },
}
